import { breakpoints } from "../../breakpoints.ts";

export class HeaderMainMenu {
	#elOpenBtn: HTMLElement;
	#elCloseBtn: HTMLElement;
	#elMenu: HTMLElement;
	#mqlXl: MediaQueryList;

	/**
	 *
	 */
	public constructor(elBtns: { open: HTMLElement; close: HTMLElement; }, elMenu: HTMLElement) {
		this.#elOpenBtn = elBtns.open;
		this.#elCloseBtn = elBtns.close;
		this.#elMenu = elMenu;

		// define 'XL' breakpoint
		this.#mqlXl = matchMedia(`(min-width: ${breakpoints.get("xl")}rem)`);

		this.#bindEvents();
	}

	/**
	 *
	 */
	#bindEvents(): void {
		this.#elOpenBtn?.addEventListener("click", this.open.bind(this));
		this.#elCloseBtn?.addEventListener("click", this.close.bind(this));

		const elsSubControl = [...this.#elMenu.querySelectorAll(".sub-control")]
			.filter(el => el instanceof HTMLElement);

		/**
		 *
		 */
		const setTabMediaAttributes = () => {
			// if media query matches (is XL+ size) collapse sub-menus
			if (this.#mqlXl.matches) {
				for (const elTab of elsSubControl) {
					document.getElementById(elTab.getAttribute("aria-controls") ?? "")?.setAttribute("aria-expanded", "false");
				}
			}
		};
		setTabMediaAttributes();

		// change role of top-level links depending on menu availability
		this.#mqlXl.addEventListener("change", setTabMediaAttributes);

		// bind click listeners to open/close sub-menus
		for (const elTab of elsSubControl) {
			elTab.addEventListener("click", this.toggleSub.bind(this));
		}
	}

	/**
	 * Open/Expand the menu
	 */
	public open(ev: Event): void {
		ev?.preventDefault();
		this.#elOpenBtn?.setAttribute("aria-pressed", "true");
		this.#elCloseBtn?.setAttribute("aria-pressed", "false");
		this.#elMenu.setAttribute("aria-expanded", "true");
	}

	/**
	 * Close/collapse the menu
	 */
	public close(ev: Event): void {
		ev?.preventDefault();
		this.#elOpenBtn?.setAttribute("aria-pressed", "false");
		this.#elCloseBtn?.setAttribute("aria-pressed", "true");
		this.#elMenu.setAttribute("aria-expanded", "false");
	}

	/**
	 * Toggle the expanded state of a sub-menu item
	 */
	public toggleSub(ev: Event): void {
		// if this is desktop layout, continue doing default action
		if (this.#mqlXl.matches) {
			return;
		}

		const el = ev.currentTarget;
		if (el && el instanceof HTMLElement) {
			ev.preventDefault();

			// toggle the controlled list's aria-expanded state
			const elList = document.getElementById(el.getAttribute("aria-controls") ?? "");
			elList?.setAttribute("aria-expanded", elList.getAttribute("aria-expanded") === "true" ? "false" : "true");
		}
	}
}
